/*
 * @Description: '关于我们'页面所有路由
 * @Author: 任录
 * @Date: 2019-07-22 16:50:00
 * @LastEditTime: 2021-09-02 17:36:39
*/

export default [
  {
    path: '/about',
    component: resolve => require(['@/views/about'], resolve),
    name: 'About',
    meta: {
      title: '走进丹氏'
    }
  },
  {
    path: '/jobDetail/:id',
    component: resolve => require(['@/views/about/JobDetail'], resolve),
    name: 'JobDetail',
    meta: {
      title: '招贤纳士',
      guidePath: true,
      jumpPath: '/about'
    }
  },
  {
    path: '/activityDetail/:id',
    component: resolve => require(['@/views/about/activityDetail'], resolve),
    name: 'ActivityDetail',
    meta: {
      title: '公司活动',
      guidePath: true,
      jumpPath: '/about'
    }
  },
  {
    path: '/customerCase/:id',
    component: resolve => require(['@/views/about/customerCase'], resolve),
    name: 'CustomerCase',
    meta: {
      title: '客户案例',
      guidePath: true,
      jumpPath: '/'
    }
  }
      
]


// WEBPACK FOOTER //
// ./src/router/about.js